import { useRoute } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import { Modal, Pressable, ScrollView, Text, View } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@assets/svg/CloseIcon";
import YoutubePlayer from "@components/YouTubePlayer";
import color from "@constants/color";
import { actions } from "@reducers/cartReducer";
import { actions as customerActions } from "@reducers/customerReducer";
import analytics from "@services/analytics";
import { useRemoteValue } from "@services/firebase";
import PlayButton from "../../assets/svg/SelfOrder/PlayButton";
import So1 from "../../assets/svg/SelfOrder/So1";
import So2 from "../../assets/svg/SelfOrder/So2";
import So3 from "../../assets/svg/SelfOrder/So3";
import So4 from "../../assets/svg/SelfOrder/So4";
import { SELF_ORDER_BANNER } from "../../constants/analyticsEventsCT";

import handleCMSNavigation from "../../utils/handleCMSNavigation";

const OrderManagement = (props) => {
  const showWidget = useRemoteValue("ab_self_order");

  const { video_link = "", link = "", link_type = "", cl_title } = props;
  const [showModal, setShowModal] = useState(false);
  const toggleModal = (value, trackEvent) => {
    setShowModal((s) => value ?? !s);
    if (trackEvent) {
      analytics.trackEvent(SELF_ORDER_BANNER.SEE_VIDEO, {
        screen: route?.name,
      });
    }
  };

  const { user } = useSelector((state) => ({
    user: state.auth.user,
  }));
  const dispatch = useDispatch();

  const route = useRoute();

  const ctaLink = () => {
    analytics.trackEvent(SELF_ORDER_BANNER.PLACE_ORDER, {
      screen: route?.name,
    });
    const payload = {
      user_id: user.user_id,
      user_name: "खुद के लिए",
    };

    dispatch(
      actions.viewCartLiteSuccess(
        { cartTotal: {}, result: [] },
        payload.user_id,
      ),
    );
    dispatch(actions.viewCartLiteRequest(payload));
    dispatch(customerActions.setSelectedContact(payload));
    handleCMSNavigation(link, link_type);
  };

  if (!showWidget) {
    return null;
  }

  return (
    <View style={{}}>
      <Header toggleModal={toggleModal} title={cl_title} />
      <Perks />
      <CtaWithCoupon ctaLink={ctaLink} />
      <VideoModal
        showModal={showModal}
        toggleModal={toggleModal}
        video_link={video_link}
      />
    </View>
  );
};

const VideoModal = ({ showModal, toggleModal, video_link }) => {
  return (
    <Modal visible={showModal} onRequestClose={() => toggleModal(false)}>
      <View
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "black",
        }}
      >
        <Pressable
          onPress={toggleModal}
          style={{
            position: "absolute",
            top: 30,
            right: 23,
            zIndex: 5,
          }}
        >
          <CloseIcon fill="#fff" />
        </Pressable>
        {!!video_link && (
          <YoutubePlayer video_link={video_link} inline={false} />
        )}
      </View>
    </Modal>
  );
};

const perksArray = [
  { title: "कैश ऑन डिलीवरी", Icon: So1 },
  { title: "रिटर्न - बिना कोई सवाल किये", Icon: So2 },
  { title: "सिर्फ ₹100 का भी आर्डर लगा सकते है ", Icon: So3 },
  { title: "24 घंटे के अंदर फ्री डिलीवरी", Icon: So4 },
];

const Play = ({ toggleModal }) => {
  return (
    <Pressable
      onPress={() => toggleModal(true, true)}
      style={{
        borderColor: color.lightBlack,
        borderRadius: 6,
        padding: 6,
        flexDirection: "row",
        borderWidth: 1,
        marginVertical: 6,
      }}
    >
      <Text style={{ marginRight: 4 }}>वीडियो देखें</Text>
      <PlayButton />
    </Pressable>
  );
};

const Header = ({ toggleModal, title }) => {
  return (
    <View
      style={{
        paddingHorizontal: 15,
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "flex-start",
        marginVertical: 20,
      }}
    >
      <Text
        numberOfLines={2}
        style={{
          fontFamily: "NotoSansDevanagari-Bold",
          fontSize: 20,
          flex: 1,
          marginRight: 8,
        }}
      >
        {title}
      </Text>
      <Play toggleModal={toggleModal} />
    </View>
  );
};

const Perks = () => {
  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={{ paddingHorizontal: 15, marginBottom: 20 }}
    >
      {perksArray.map(({ title, Icon }, index) => (
        <View
          key={index}
          style={{
            backgroundColor: "rgba(0,0,0,0.05)",
            padding: 10,
            marginRight: 10,
            height: 120,
            width: 120,
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 20,
          }}
        >
          <Icon />
          <Text style={{ textAlign: "center", marginTop: 6 }}>{title}</Text>
        </View>
      ))}
    </ScrollView>
  );
};
const CtaWithCoupon = ({ ctaLink }) => {
  return (
    <>
      <Pressable
        onPress={ctaLink}
        style={{
          backgroundColor: color.primary,
          marginHorizontal: 15,
          borderRadius: 10,
        }}
      >
        <Text
          style={{
            color: "white",
            fontFamily: "NotoSansDevanagari-Bold",
            fontSize: 16,
            paddingVertical: 13,
            textAlign: "center",
          }}
        >
          खुद के लिए आर्डर लगाएं
        </Text>
      </Pressable>

      <Text style={{ marginTop: 10, marginBottom: 20, paddingHorizontal: 15 }}>
        <Text style={{ fontFamily: "NotoSansDevanagari-Bold" }}>CITY50 </Text>
        कूपन कोड लगाएं और पहले आर्डर पर
        <Text style={{ fontFamily: "NotoSansDevanagari-Bold" }}> ₹50 ऑफ </Text>
        पाएं I
      </Text>
    </>
  );
};

export default OrderManagement;
